module.exports = __webpack_public_path__ + "static/media/ChannelSong.Gujarati.f7127672.jpg";